import { render, staticRenderFns } from "./ChatBanPage.vue?vue&type=template&id=a5a4eafa"
import script from "./ChatBanPage.vue?vue&type=script&lang=js"
export * from "./ChatBanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports